import { Alert } from "@mui/material";
import React from "react";

const Fallback = () => {
  return (
    <Alert severity={"error"}>
      Üzgünüz ancak bir hata meydana geldi ve bu durumu geliştiricilere haber
      verdik. Sayfayı yenileyerek işleminizi tekrar deneyebilirsiniz.
    </Alert>
  );
};

export default Fallback;
